const { ActionTypes } = require("../constants/action_types");

const initialState = ""

const SelectResourceReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SELECTRESOURCETYPE:
            return action.payload
        default:
            return state
    }
}

export default SelectResourceReducer